import React from 'react';
import { Text } from '@rneui/themed';
export const Duration = ({ duration, ...props }) => {
    if (!duration || !duration.length || !duration.unit)
        return null;
    const { unit, length } = duration;
    let display = '';
    if (unit === 'seconds') {
        const parts = [];
        const min = Math.ceil(length / 60);
        const hrs = Math.floor(min / 60);
        if (hrs > 0) {
            parts.push(`${hrs}h`);
            const remainder = min - (hrs * 60);
            if (remainder > 0) {
                parts.push(`${remainder}m`);
            }
        }
        else {
            parts.push(`${min}m`);
        }
        display = `${parts.join(' ')}`;
    }
    else if (unit === 'pages') {
        display = `${length} pages`;
    }
    return React.createElement(Text, { ...props }, display);
};
//# sourceMappingURL=Duration.js.map